exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Home {\n  /*.ant-table-row > p {\n    text-align: justify;\n  }*/ }\n  .Home img {\n    width: 100%; }\n  .Home .ant-alert-with-description .ant-alert-icon {\n    font-size: 40px;\n    left: 10px;\n    top: 20px; }\n", ""]);

